// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@bg/XDL/PreStyle/typography";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { css } from "styled-components";

productBrandStyles.nameText = {
    css: css`
        width: 100%;
        ${wrapInContainerStyles}
    `,
    size: fontConfig.fontSize.regular,
    weight: fontConfig.weight.semiBold,
};

productBrandStyles.nameLink = {
    css: css`
        width: 100%;
    `,
    typographyProps: {
        size: fontConfig.fontSize.regular,
    },
};
